import { render, staticRenderFns } from "./ProfitLossChart.vue?vue&type=template&id=6b0423e3"
import script from "./ProfitLossChart.vue?vue&type=script&lang=js"
export * from "./ProfitLossChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports